import { __assign } from "tslib";
import { textStyle } from '../../v2/theme';
export default {
  container: {
    padding: 10
  },
  subHeader: __assign({
    color: "#707070",
    marginTop: 10,
    marginBottom: 20,
    marginHorizontal: 10
  }, textStyle.formBodyTotal),
  headerTitle: {
    marginHorizontal: 10
  },
  titleView: {
    flex: 1,
    shadowColor: "rgba(0,0,0, .08)",
    shadowOffset: {
      height: 4,
      width: 2
    },
    shadowOpacity: 1,
    shadowRadius: 12,
    elevation: 4,
    marginHorizontal: 10,
    marginBottom: 10
  },
  linearGradient: {
    flexDirection: 'row',
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 10,
    flex: 1,
    paddingVertical: 25
  },
  titleWrapper: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center'
  },
  titleText: __assign({
    textDecorationLine: 'none',
    textTransform: 'uppercase',
    marginHorizontal: 10
  }, textStyle.defaultTextTitle),
  links: {
    textDecoration: 'none',
    cursor: 'pointer'
  },
  iconImage: {
    width: 32,
    height: 32
  }
};